import * as types from "../actions/actionTypes";

const initialModalData = { link: "", onClick: () => {} };
const initialState = {
  modalStatus: false,
  modalData: initialModalData
};

const PettyCashierSelection = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_SELECTION_MODAL_DATA:
      return { ...state, modalStatus: true, modalData: action.data };
    case types.PETTY_CASHIER_SELECTION_CLOSE_MODAL:
      return { ...state, modalStatus: false };
    default:
      return state;
  }
};

export default PettyCashierSelection;
